module.exports = __webpack_public_path__ + "static/media/zolePlayed_500000_1000000.30331273.png";